import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const ProductionCapacityForm = ({ formData, onChange, errors }) => {
  const shiftOptions = [
    { value: '1', label: '1 Shift (8 jam)' },
    { value: '2', label: '2 Shift (16 jam)' },
    { value: '3', label: '3 Shift (24 jam)' }
  ];

  const handleInputChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="card space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b border-border">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="Factory" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-semibold">Kapasitas Produksi Saat Ini</h2>
          <p className="text-sm text-muted-foreground">Data volume produksi harian dan kapasitas maksimal</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Volume Produksi Harian (Liter)"
          type="number"
          placeholder="Contoh: 5000"
          value={formData?.dailyProductionVolume || ''}
          onChange={(e) => handleInputChange('dailyProductionVolume', e?.target?.value)}
          error={errors?.dailyProductionVolume}
          required
          description="Total liter susu yang diproses per hari"
        />

        <Input
          label="Kapasitas Maksimal (Liter/Hari)"
          type="number"
          placeholder="Contoh: 8000"
          value={formData?.maxCapacity || ''}
          onChange={(e) => handleInputChange('maxCapacity', e?.target?.value)}
          error={errors?.maxCapacity}
          required
          description="Kapasitas produksi maksimal fasilitas"
        />

        <Select
          label="Pola Shift Operasional"
          options={shiftOptions}
          value={formData?.shiftPattern || ''}
          onChange={(value) => handleInputChange('shiftPattern', value)}
          error={errors?.shiftPattern}
          required
          description="Jumlah shift kerja per hari"
        />

        <Input
          label="Jumlah Karyawan Produksi"
          type="number"
          placeholder="Contoh: 25"
          value={formData?.productionStaff || ''}
          onChange={(e) => handleInputChange('productionStaff', e?.target?.value)}
          error={errors?.productionStaff}
          required
          description="Total tenaga kerja di lini produksi"
        />

        <Input
          label="Tingkat Utilisasi (%)"
          type="number"
          placeholder="Contoh: 62.5"
          value={formData?.utilizationRate || ''}
          onChange={(e) => handleInputChange('utilizationRate', e?.target?.value)}
          error={errors?.utilizationRate}
          required
          min="0"
          max="100"
          description="Persentase kapasitas yang digunakan"
        />

        <Input
          label="Waktu Operasional (Jam/Hari)"
          type="number"
          placeholder="Contoh: 16"
          value={formData?.operationalHours || ''}
          onChange={(e) => handleInputChange('operationalHours', e?.target?.value)}
          error={errors?.operationalHours}
          required
          min="1"
          max="24"
          description="Total jam operasional per hari"
        />
      </div>
      {formData?.dailyProductionVolume && formData?.maxCapacity && (
        <div className="mt-6 p-4 rounded-lg bg-muted">
          <div className="flex items-center justify-between">
            <span className="text-sm font-medium">Efisiensi Kapasitas:</span>
            <span className="text-lg font-bold text-primary data-text">
              {((parseFloat(formData?.dailyProductionVolume) / parseFloat(formData?.maxCapacity)) * 100)?.toFixed(1)}%
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductionCapacityForm;